var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTIckGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_522_4515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 25.0833C19.1735 25.0833 24.5834 19.6734 24.5834 13C24.5834 6.32655 19.1735 0.916656 12.5001 0.916656C5.82664 0.916656 0.416748 6.32655 0.416748 13C0.416748 19.6734 5.82664 25.0833 12.5001 25.0833Z",
    fill: "#196A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1093 18.0292L7.27595 15.2617C7.21466 15.2021 7.16595 15.1308 7.13268 15.0521C7.09942 14.9734 7.08228 14.8888 7.08228 14.8033C7.08228 14.7179 7.09942 14.6333 7.13268 14.5545C7.16595 14.4758 7.21466 14.4046 7.27595 14.345L8.21553 13.4283C8.34153 13.3062 8.51009 13.238 8.68553 13.238C8.86097 13.238 9.02953 13.3062 9.15553 13.4283L10.8422 15.0771L15.5726 7.88541C15.6702 7.74029 15.8204 7.63881 15.9915 7.60243C16.1626 7.56604 16.3411 7.59759 16.4893 7.69041L17.6076 8.39291C17.6807 8.43783 17.7439 8.49695 17.7937 8.56678C17.8435 8.63662 17.8787 8.71573 17.8973 8.79943C17.9159 8.88314 17.9175 8.96973 17.9021 9.05406C17.8866 9.1384 17.8543 9.21878 17.8072 9.29041L12.2059 17.8087C12.0937 17.9755 11.9463 18.1156 11.774 18.2192C11.6018 18.3228 11.409 18.3874 11.2091 18.4084C11.0092 18.4294 10.8071 18.4063 10.6171 18.3408C10.4271 18.2753 10.2537 18.1689 10.1093 18.0292Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_4515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTIckGreen);
export default __webpack_public_path__ + "static/media/TIckGreen.983a70246994809676300f04f8ce9d7c.svg";
export { ForwardRef as ReactComponent };